/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  GetProductPageComponentsQueryResponse,
  GetProductPageComponentsPathParams,
} from "../types/GetProductPageComponents.ts"

export const getProductPageComponentsQueryKey = (
  productSheetGroupId: GetProductPageComponentsPathParams["productSheetGroupId"]
) =>
  [
    {
      url: "/v1/organization-settings/get-product-page-components/:productSheetGroupId",
      params: { productSheetGroupId },
    },
  ] as const

export type GetProductPageComponentsQueryKey = ReturnType<
  typeof getProductPageComponentsQueryKey
>

/**
 * @summary Get product page components by productSheetGroup
 * {@link /v1/organization-settings/get-product-page-components/:productSheetGroupId}
 */
export async function getProductPageComponents(
  productSheetGroupId: GetProductPageComponentsPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetProductPageComponentsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-product-page-components/${productSheetGroupId}`,
    ...requestConfig,
  })
  return res
}

export function getProductPageComponentsQueryOptions(
  productSheetGroupId: GetProductPageComponentsPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getProductPageComponentsQueryKey(productSheetGroupId)
  return queryOptions<
    ResponseConfig<GetProductPageComponentsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetProductPageComponentsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productSheetGroupId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getProductPageComponents(productSheetGroupId, config)
    },
  })
}

/**
 * @summary Get product page components by productSheetGroup
 * {@link /v1/organization-settings/get-product-page-components/:productSheetGroupId}
 */
export function useGetProductPageComponents<
  TData = ResponseConfig<GetProductPageComponentsQueryResponse>,
  TQueryData = ResponseConfig<GetProductPageComponentsQueryResponse>,
  TQueryKey extends QueryKey = GetProductPageComponentsQueryKey,
>(
  productSheetGroupId: GetProductPageComponentsPathParams["productSheetGroupId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetProductPageComponentsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ??
    getProductPageComponentsQueryKey(productSheetGroupId)

  const query = useQuery(
    {
      ...getProductPageComponentsQueryOptions(productSheetGroupId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
